import { composeAction } from '@gef-ui/redux-common/utils';
import memoizeWithAllArguments from "@gef-ui/utils/memoizeWithAllArguments";
import { handleActions } from '@gef-ui/utils/fsaActions';
import invariant from 'invariant';
import assoc from "ramda/es/assoc";
import dissoc from "ramda/es/dissoc";
import mapKeys from "ramda-extension/es/mapKeys";
import { defaultFieldState, fieldActions } from '../../constants';
const defaultRegisteredField = ({ fieldName, section, initiallyDirty })=>({
        fieldName,
        placement: {
            section
        },
        state: defaultFieldState({
            initiallyDirty
        })
    });
const registerField = (state, { payload: { fieldName, section, initiallyDirty } })=>{
    invariant(!state[fieldName], `${fieldName} already registered, report a bug`);
    return assoc(fieldName, defaultRegisteredField({
        fieldName,
        section,
        initiallyDirty
    }), state);
};
const unregisterField = (state, { payload })=>{
    invariant(state[payload], `${payload} not found in registeredFields, report a bug`);
    return dissoc(payload, state);
};
const registerFieldMap = {
    [fieldActions.REGISTER_FIELD]: registerField,
    [fieldActions.UNREGISTER_FIELD]: unregisterField
};
export default memoizeWithAllArguments((formName, defaultState = {})=>handleActions(mapKeys(composeAction(formName), registerFieldMap), defaultState));
